const firebaseConfig = {
    apiKey: "AIzaSyDNRb8JhE-UuTxE-1c7ltY1Ql_lvZnzpeM",
    authDomain: "volunteer-network-4a048.firebaseapp.com",
    databaseURL: "https://volunteer-network-4a048.firebaseio.com",
    projectId: "volunteer-network-4a048",
    storageBucket: "volunteer-network-4a048.appspot.com",
    messagingSenderId: "1048577521371",
    appId: "1:1048577521371:web:db016087c152448292fefe"
  };
  export default firebaseConfig;